import {FC, ReactNode} from "react";
import {useTranslation} from "react-i18next";
import {Badge, BadgeVariant} from "@interstate/components/Badge";

export interface ReviewPlanBadgeProps {
  caId: string;
  qualifier: string;
  variant: BadgeVariant;
  startIcon: ReactNode;
  labelKey: string;
}

export const ReviewPlanBadge: FC<ReviewPlanBadgeProps> = ({
  caId,
  qualifier,
  variant,
  startIcon,
  labelKey
}) => {
  const {t} = useTranslation();
  return (
    <div>
      <Badge
        id={`review-plan-badge-${caId}--${qualifier}`}
        data-testid={`review-plan-badge-${caId}--${qualifier}`}
        className={`review-plan-badge review-plan-badge--${qualifier}`}
        variant={variant}
        startIcon={startIcon}>
        <span className={"review-plan-badge-label"}>{t(labelKey)}</span>
      </Badge>
    </div>
  );
};
